import axios from '@axios'

export const state = {
  dispatchers: [],
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecord: 0,
}

export const getters = {
  allDispatchers: (state) => state.dispatchers,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_DISPATCHERS: (state, resp) => {
    if (!resp) return null
    state.dispatchers = resp.dispatchers
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecords = resp.totalRecords
  },
  DELETE_DISPATCHER: (state, dispatcher) => {
    state.dispatchers = state.dispatchers.filter((w) => w.id !== dispatcher.id)
  },
}

export const actions = {
  async getDispatchers({ commit }, params = {}) {
    await axios
      .get('/api/dispatchers', { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_DISPATCHERS', resp.data)
        }
      })
      .catch((err) => {
        commit(
          'GET_DISPATCHERS',
          err.response.status === 404 ? { dispatchers: [] } : null
        )
      })
  },
  async createDispatcher({ commit }, dispatcher) {
    return axios.post(`/api/dispatchers`, dispatcher)
  },
  async editDispatcher({ commit }, dispatcher) {
    return axios.put(`/api/dispatchers`, dispatcher)
  },
  async deleteDispatcher({ commit }, dispatcher) {
    await axios.delete(`/api/dispatchers/${dispatcher.id}`).then((resp) => {
      if (resp.status === 204) {
        commit('DELETE_DISPATCHER', dispatcher)
      }
    })
  },
}
